import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../lib/seo';

function PaymentError() {
  useEffect(() => {
    setPageMeta({
      title: 'Payment Error — Elorimi',
      description: 'There was a problem processing your Elorimi payment.',
    });
  }, []);

  return (
    <div className="payment-error-section">
      {/* Animated Background */}
      <div className="bg-animation">
        <div className="bg-mesh"></div>
        <div className="bg-grid"></div>
        <div className="bg-glow bg-glow-1"></div>
        <div className="bg-glow bg-glow-2"></div>
        <div className="bg-glow bg-glow-3"></div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="payment-result-card glass">
              <div className="result-icon error">
                <i className="fas fa-times"></i>
              </div>

              <h2 className="result-title">Payment Failed</h2>
              
              <p className="result-message">
                We're sorry, but your payment could not be processed. This could be due to:
              </p>

              <ul className="error-reasons">
                <li>Invalid or expired card</li>
                <li>Insufficient funds</li>
                <li>Payment gateway issues</li>
                <li>Network connection problems</li>
              </ul>

              <div className="result-actions">
                <Link to="/dashboard" className="btn btn-outline-primary btn-lg">
                  Go Back
                </Link>
              </div>

              <div className="result-footer">
                <p>Need help? <a href="/contact">Contact Support</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .payment-error-section {
          padding: 120px 20px 60px;
          position: relative;
          min-height: 100vh;
        }

        .payment-result-card {
          background: rgba(255, 255, 255, 0.02);
          border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: var(--radius-xl);
          padding: 3rem 2rem;
          text-align: center;
          max-width: 500px;
          margin: 0 auto;
        }

        .result-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          font-size: 2rem;
        }

        .result-icon.error {
          background: rgba(231, 76, 60, 0.1);
          border: 2px solid #e74c3c;
          color: #e74c3c;
        }

        .result-title {
          font-family: 'Poppins', sans-serif;
          font-size: 1.75rem;
          font-weight: 700;
          color: var(--white);
          margin-bottom: 1rem;
        }

        .result-message {
          color: var(--gray-600);
          margin-bottom: 1rem;
          line-height: 1.6;
        }

        .error-reasons {
          text-align: left;
          list-style: none;
          padding: 0;
          margin: 1.5rem 0 2rem;
        }

        .error-reasons li {
          position: relative;
          padding-left: 1.5rem;
          margin-bottom: 0.5rem;
          color: var(--gray-600);
          font-size: 0.9rem;
        }

        .error-reasons li::before {
          content: '•';
          position: absolute;
          left: 0;
          color: var(--gray-700);
        }

        .result-actions {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .result-actions .btn {
          width: 100%;
          justify-content: center;
        }

        .result-footer {
          color: var(--gray-700);
          font-size: 0.85rem;
        }

        .result-footer a {
          color: var(--primary);
          text-decoration: none;
        }

        .result-footer a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}

export default PaymentError;
